import React, { useState } from "react";
import BaseInput from "../../../toolkit/baseInput";
import BaseAlphabeticInput from "../../../toolkit/baseAlphabeticInput";
import BaseNumericInput from "../../../toolkit/baseNumericInput";
import DatePicker from "../../../Home/components/common/DatePicker";
import moment from "moment";
import s from "./styles.scss";
import { Alert, Label, Button } from "reactstrap";
import { MedioProspeccion } from "../../../types-business/User";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  putExtranjeroBandera,
  getPartnerMembershipByPartnerId
} from "../../../Home/actions/partners";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import BaseButtonWithIconAndTooltip from "../../../toolkit/baseButtonWithIconAndTooltip";
import { faBan, faEdit } from "@fortawesome/free-solid-svg-icons";
import { userHasPermission } from "../../../utils/accessTree";
import permissionCodes from "../../../utils/permissionCodes";
import BaseAlphanumericInput from "../../../toolkit/baseAlphanumericInput";
import ConfirmacionVetadoModal from "./ConfirmacionVetadoModal";

const getOption = medioProspeccion => medioProspeccion.replace(/_/g, " ");

const mpOptions = [
  {
    value: "",
    label: "Seleccione una opción"
  }
];

for (const key in MedioProspeccion) {
  mpOptions.push({
    value: MedioProspeccion[key],
    label: getOption(MedioProspeccion[key])
  });
}

const MALE = "MASCULINO";
const FEMALE = "FEMENINO";
const CONCESIONARIO_TIPO = "CONCESIONARIO";
const CORPORATIVO_TIPO = "CORPORATIVO";
const PROSPECTO_TIPO = "PROSPECTO";

export const getCleanFields = () => {
  return {
    correoElectronico: "",
    nombre: "",
    primerApellido: "",
    segundoApellido: "",
    fechaNacimiento: "",
    medioProspeccion: null,
    codigoPostal: "",
    colonia: "",
    numeroTelefono: "",
    extension: "",
    sexo: FEMALE,
    convenioId: "",
    empresaId: "",
    convenioData: { value: "", label: "Seleccionar" },
    clubData: { value: "", label: "Seleccionar" },
    securitySpace: "",
    esExtranjero: false,
    curp: "",
    folio: null,
    precioMembresia: null,
    mantenimiento: null,
    precioMantenimiento: null,
    curpAprobada: false
  };
};

const genreOptions = [
  { value: FEMALE, label: "FEMENINO" },
  { value: MALE, label: "MASCULINO" }
];
const extranjeroOptions = [
  { value: "0", label: "No" },
  { value: "1", label: "Sí" }
];

export default ({
  fields,
  onChangeFactory,
  re,
  onChangeFechaNacimiento,
  creatingProspectError,
  onChangeNumber,
  isMoralPersonType,
  viewMode,
  empresasConvenio,
  onChangeCurp,
  verifyCurp,
  gettingCurp,
  curpFormatoValidado,
  showErrors,
  curpRenapoValidado,
  vetarPersona,
  addMessage
}) => {
  const [showModal, setShowModal] = useState(false);
  const [accionVetado, setAccionVetado] = useState(false);

  const shouldShowBlackListButton = () => {
    if (!fields.personaId) return false;

    const hasAgregarPermission = userHasPermission(
      permissionCodes.AGREGAR_PERSONA_BLACKLIST
    );
    const hasQuitarPermission = userHasPermission(
      permissionCodes.QUITAR_PERSONA_BLACKLIST
    );

    if (fields.vetado) {
      return hasQuitarPermission;
    } else {
      return hasAgregarPermission;
    }
  };

  const handleClickVetado = () => {
    const isVetado = !fields.vetado;

    const requiredPermission = isVetado
      ? permissionCodes.AGREGAR_PERSONA_BLACKLIST
      : permissionCodes.QUITAR_PERSONA_BLACKLIST;

    if (!userHasPermission(requiredPermission)) {
      errorNotification(
        isVetado
          ? "No tienes permisos para agregar personas a Black List"
          : "No tienes permisos para quitar personas de Black List"
      );
      return;
    }

    setAccionVetado(isVetado);
    setShowModal(true);
  };

  const handleConfirmVetado = motivo => {
    const accion = accionVetado
      ? "agregado a Black List"
      : "quitado de Black List";
    infoNotification(
      accionVetado
        ? "Agregando a Black List a la persona seleccionada"
        : "Quitando de Black List a la persona seleccionada"
    );

    addMessage({
      personaId: fields.personaId,
      titulo: `${fields.nombreCompleto} ${accion}`,
      descripcion: motivo,
      alerta: null,
      fechaAlerta: null
    }).catch(error => {
      errorNotification(
        "No se pudo agregar el mensaje de agregado/quitado de Black List"
      );
      console.error(error);
    });

    vetarPersona(fields.personaId, accionVetado);

    if (onChangeFactory) {
      onChangeFactory("vetado")({ target: { value: accionVetado } });
    }
  };

  const redirigirAMembresia = () => {
    getPartnerMembershipByPartnerId(fields.personaId)
      .then(({ data }) => {
        const membresiaSocioUrl =
          data && data.idPublico
            ? `/membresias-socios?idClub=${data.idClubBase}&idPublico=${data.idPublico}`
            : null;

        if (membresiaSocioUrl) {
          window.location.href = membresiaSocioUrl;
        } else {
          infoNotification(
            "No se encontró membresía asociada para redireccionar"
          );
        }
      })
      .catch(error => {
        console.error("Error al obtener datos de membresía:", error);
        errorNotification("No se pudo redireccionar a la membresía");
      });
  };

  const agreementOptions = empresasConvenio.map(agreement => ({
    id: `${agreement.convenioId}-${agreement.empresaId}`,
    label: agreement.empresa
  }));
  const selected = agreementOptions.filter(
    opt => opt.id == fields.convenioId + "-" + fields.empresaId
  );

  const [curpError, setCurpError] = useState("");
  const [localGettingCurp, setLocalGettingCurp] = useState(false);
  const [hasCurpData, setHasCurpData] = useState(false);
  const [curpRequired, setCurpRequired] = useState(
    !fields.esExtranjero ||
      fields.esExtranjero != "0" ||
      (fields.tipo != CONCESIONARIO_TIPO && fields.tipo != CORPORATIVO_TIPO)
  );

  return (
    <form>
      <div className="form-row">
        <div className="col">
          <BaseAlphanumericInput
            label={"Folio"}
            name="prospectoFolio"
            id="prospectoFolio"
            placeholder="Folio"
            value={fields.folio}
            onChange={onChangeFactory("folio", true)}
            uppercase={true}
            disabled={!!viewMode}
            maxlength={"10"}
          />
        </div>
        {!fields.personaId && (
          <div className="col">
            <BaseInput
              label={"Es extranjero"}
              name="esExtranjero"
              type="select"
              options={extranjeroOptions}
              id="esExtranjero"
              placeholder="Es extranjero"
              value={fields.esExtranjero ? "1" : "0"}
              onChange={evt => {
                if (evt.target.value == "1") {
                  setCurpError("");
                  setCurpRequired(false);
                } else {
                  setCurpRequired(true);
                }
                onChangeFactory("esExtranjero")(evt);
              }}
              errors={re && re.mapFieldErrors("esExtranjero")}
              disabled={fields.curpAprobada || !!viewMode}
            />
          </div>
        )}
        <div className="col">
          <BaseInput
            label={"CURP"}
            name="curp"
            id="curp"
            placeholder="CURP"
            value={fields.curp}
            upperCase={true}
            onChange={onChangeFactory("curp", true)}
            disabled={curpRenapoValidado}
            errors={
              fields.curp && showErrors && !curpFormatoValidado && curpRequired
                ? ["El formato de la CURP no es válido"]
                : /*                 : showErrors && (!fields.curp || fields.curp === "")
                ? ["Este campo es obligatorio"] */
                  []
            }
          />
        </div>
        <div className="col">
          <Button
            className={`buttonMarginTop primaryButton mt-4`}
            size="sm"
            block
            onClick={e => {
              e.preventDefault();
              if (fields.curp && curpFormatoValidado && verifyCurp) {
                verifyCurp(fields.curp);
              }
            }}
            disabled={
              !fields.curp ||
              !curpFormatoValidado ||
              gettingCurp ||
              curpRenapoValidado
            }
          >
            {gettingCurp ? "Verificando..." : "Verificar CURP"}
          </Button>
        </div>
        <div className="col">
          <BaseAlphabeticInput
            label={"Nombre"}
            name="nombre"
            id="nombre"
            placeholder="Nombre"
            value={fields.nombre}
            onChange={onChangeFactory("nombre", true)}
            errors={re && re.mapFieldErrors("nombre")}
            uppercase={true}
            disabled={
              fields.curpAprobada ||
              !!viewMode ||
              gettingCurp ||
              curpRenapoValidado
            }
          />
        </div>
      </div>
      <div className="form-row">
        <div className=" col">
          <BaseAlphabeticInput
            label={"Apellido Paterno"}
            name="primerApellido"
            type="text"
            id="primerApellido"
            placeholder="Apellido Paterno"
            value={fields.primerApellido}
            onChange={onChangeFactory("primerApellido", true)}
            errors={re && re.mapFieldErrors("primerApellido")}
            uppercase={true}
            disabled={
              fields.curpAprobada ||
              !!viewMode ||
              gettingCurp ||
              curpRenapoValidado
            }
          />
        </div>
        <div className=" col">
          <BaseAlphabeticInput
            label={"Apellido Materno"}
            name="segundoApellido"
            type="text"
            id="segundoApellido"
            placeholder="Apellido Materno"
            value={fields.segundoApellido}
            onChange={onChangeFactory("segundoApellido", true)}
            errors={re && re.mapFieldErrors("segundoApellido")}
            uppercase={true}
            disabled={
              fields.curpAprobada ||
              !!viewMode ||
              gettingCurp ||
              curpRenapoValidado
            }
          />
        </div>
        <div className=" col">
          <DatePicker
            label={
              !isMoralPersonType ? "Fecha de Nacimiento" : "Fecha de Registro"
            }
            name="fechaNacimiento"
            id="fechaNacimiento"
            selected={fields.fechaNacimiento || moment().subtract(1, "years")}
            onChange={onChangeFechaNacimiento}
            errors={re && re.mapFieldErrors("fechaNacimiento")}
            maxDate={moment().add(2, "years")}
            minDate={moment().subtract(100, "years")}
            disabled={
              fields.curpAprobada ||
              !!viewMode ||
              gettingCurp ||
              curpRenapoValidado
            }
          />
        </div>
        <div className=" col">
          <BaseInput
            label={"Sexo"}
            name="sexo"
            type="select"
            options={genreOptions}
            id="sexo"
            placeholder="Sexo"
            value={fields.sexo}
            onChange={onChangeFactory("sexo")}
            errors={re && re.mapFieldErrors("sexo")}
            disabled={!!viewMode || gettingCurp}
          />
        </div>
      </div>
      <div className="form-row">
        <div className=" col">
          <BaseInput
            label={"Correo Electrónico"}
            name="correoElectronico"
            type="correoElectronico"
            id="correoElectronico"
            placeholder="Correo Electrónico"
            value={fields.correoElectronico}
            onChange={onChangeFactory("correoElectronico")}
            errors={re && re.mapFieldErrors("correoElectronico")}
            disabled={!!viewMode}
          />
        </div>
        <div className=" col">
          <BaseNumericInput
            label={"Número de Teléfono"}
            name="numeroTelefono"
            type="text"
            id="numeroTelefono"
            placeholder="Número de Teléfono"
            value={fields.numeroTelefono}
            onChange={onChangeNumber("numeroTelefono")}
            errors={re && re.mapFieldErrors("numeroTelefono")}
            maxlength={"10"}
            disabled={!!viewMode}
          />
        </div>
        <div className=" col">
          <BaseNumericInput
            label={"Extensión"}
            name="extension"
            type="text"
            id="extension"
            placeholder="Extensión"
            value={fields.extension}
            onChange={onChangeNumber("extension")}
            errors={re && re.mapFieldErrors("extension")}
            maxlength={"5"}
            disabled={!!viewMode}
          />
        </div>
        {!!fields.personaId && (
          <div className=" col mt-4" style={{ fontSize: "0.8em" }}>
            <span>
              {fields.esExtranjero
                ? "Nacionalidad: EXTRANJERA"
                : "Nacionalidad: MEXICANA"}
            </span>
            {userHasPermission(
              permissionCodes.PROSPECT_EDITION_BANDERA_EXTRANJERO
            ) && (
              <BaseButtonWithIconAndTooltip
                id={`esExtranjero`}
                icon={fields.esExtranjero ? faBan : faEdit}
                color={fields.esExtranjero ? "#710" : "#000"}
                tooltipTitle={
                  fields.esExtranjero
                    ? "Configurar como NO extranjero"
                    : "Configurar como extranjero"
                }
                onClick={() => {
                  infoNotification("Aplicando la configuración de extranjeros");
                  putExtranjeroBandera(fields.personaId, !fields.esExtranjero)
                    .then(resp => {
                      onChangeFactory("esExtranjero")(!fields.esExtranjero);
                      successNotification(
                        "Configuración aplicada exitosamente"
                      );
                    })
                    .catch(err => {
                      errorNotification(
                        "No es posible aplicar la configuración de extranjero"
                      );
                    });
                }}
              />
            )}
          </div>
        )}

        {!!fields.personaId && shouldShowBlackListButton() && (
          <div className="col">
            <Button
              className={`buttonMarginTop ${
                fields.vetado ? "btn-success" : "btn-danger"
              } mt-4`}
              size="sm"
              block
              onClick={handleClickVetado}
              disabled={
                !userHasPermission(
                  fields.vetado
                    ? permissionCodes.QUITAR_PERSONA_BLACKLIST
                    : permissionCodes.AGREGAR_PERSONA_BLACKLIST
                )
              }
            >
              {fields.vetado ? "QUITAR DE BLACK LIST" : "AGREGAR A BLACK LIST"}
            </Button>
          </div>
        )}

        {!!fields.personaId && (
          <ConfirmacionVetadoModal
            show={showModal}
            onHide={() => setShowModal(false)}
            onConfirm={handleConfirmVetado}
            isVetado={accionVetado}
            nombrePersona={fields.nombreCompleto || `ID: ${fields.personaId}`}
            onVerDetalle={redirigirAMembresia}
          />
        )}
      </div>
      <div className="form-row">
        {(fields.tipo || PROSPECTO_TIPO) == PROSPECTO_TIPO && (
          <div className=" col">
            <BaseInput
              label={"Medio de Prospección"}
              name="medioProspeccion"
              type="select"
              options={mpOptions}
              id="medioProspeccion"
              placeholder="Medio de Prospección"
              value={fields.medioProspeccion}
              onChange={onChangeFactory("medioProspeccion")}
              errors={re && re.mapFieldErrors("medioProspeccion")}
              disabled={!!viewMode}
            />
          </div>
        )}
        {(fields.tipo || PROSPECTO_TIPO) == PROSPECTO_TIPO && (
          <div className=" col">
            <Label className={s.label}>Convenio:</Label>
            <Typeahead
              label={"Convenio"}
              name="convenioId"
              type="select"
              id="convenioId"
              promptText={"Convenio"}
              bsSize={"sm"}
              emptyLabel={"Sin coincidencias"}
              selected={selected}
              options={agreementOptions}
              onChange={sel => {
                const fx = onChangeFactory("convenioId");
                const fxEmp = onChangeFactory("empresaId");
                const convenioId =
                  sel.length > 0 ? sel[0]["id"].split("-")[0] : null;
                const empresaId =
                  sel.length > 0 ? sel[0]["id"].split("-")[1] : null;

                fx({
                  target: {
                    value: convenioId
                  }
                });

                fxEmp({
                  target: {
                    value: empresaId
                  }
                });
              }}
            />
          </div>
        )}
        {!!fields && (fields.tipo || PROSPECTO_TIPO) == PROSPECTO_TIPO && (
          <>
            <div className=" col">
              <BaseNumericInput
                type="text"
                label={"Precio membresía"}
                name="prospectoPrecioMembresia"
                id="prospectoPrecioMembresia"
                placeholder="Precio membresía"
                value={fields.precioMembresia}
                onChange={onChangeNumber("precioMembresia")}
                errors={
                  re &&
                  fields.hasOwnProperty("precioMembresia") &&
                  re.mapFieldErrors("precioMembresia")
                }
                disabled={!!viewMode}
                maxlength={8}
              />
            </div>
            <div className=" col">
              <BaseAlphanumericInput
                type="text"
                label={"Mantenimiento"}
                name="prospectoMantenimiento"
                id="prospectoMantenimiento"
                placeholder="Mantenimiento"
                value={fields.mantenimiento}
                onChange={onChangeFactory("mantenimiento", true)}
                errors={
                  re &&
                  fields.hasOwnProperty("mantenimiento") &&
                  re.mapFieldErrors("mantenimiento")
                }
                uppercase={true}
                disabled={!!viewMode}
                maxlength={49}
              />
            </div>
            <div className=" col">
              <BaseNumericInput
                type="text"
                label={"Precio mantenimiento"}
                name="prospectoPrecioMantenimiento"
                id="prospectoPrecioMantenimiento"
                placeholder="Precio mantenimiento"
                value={fields.precioMantenimiento}
                onChange={onChangeNumber("precioMantenimiento")}
                errors={
                  re &&
                  fields.hasOwnProperty("precioMantenimiento") &&
                  re.mapFieldErrors("precioMantenimiento")
                }
                disabled={!!viewMode}
                maxlength={8}
              />
            </div>
          </>
        )}
      </div>
      {creatingProspectError && (
        <span>
          <hr />
          <Alert color="danger">
            Ocurrio un error creando el prospecto. Intente nuevamente.
          </Alert>
        </span>
      )}
    </form>
  );
};
